import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ac-form-control" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle my-4" }, "Başlık", -1)
const _hoisted_3 = { class: "flex border pl-2 items-center" }
const _hoisted_4 = {
  key: 0,
  class: "ac-form-control"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle my-4" }, "Renk", -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = {
  key: 1,
  class: "ac-form-control"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "subtitle my-4"
}, "Açıklama", -1)
const _hoisted_9 = { class: "flex items-center" }

import { ref, Ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'addMeta',
  props: ["meta", "existingMeta", "hasColor", "hasDesc"],
  emits: ["addNewMeta", "updatedMeta"],
  setup(__props, { emit: __emit }) {


const props = __props

const newName: Ref<string> = ref(props.existingMeta ? props.existingMeta.name : "")
const newColor: Ref<string> = ref(props.existingMeta ? props.existingMeta.color ? props.existingMeta.color : "" : "")
const newDesc = ref<string>(props.existingMeta ? props.existingMeta.desc : "")

const emit = __emit

function handleSubmit() {
    const emittedData = { name: newName.value };

    // Add color if it has a value
    if (newColor.value) {
        emittedData.color = newColor.value;
    }

    // Add desc if it has a value
    if (newDesc.value) {
        emittedData.desc = newDesc.value;
    }

    // Emit the appropriate event
    if (props.existingMeta) {
        emit("updatedMeta", emittedData);
    } else {
        emit("addNewMeta", emittedData);
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    class: "ac-main-form"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newName).value = $event)),
          type: "text",
          required: "",
          class: "w-full title-field p-3"
        }, null, 512), [
          [_vModelText, newName.value]
        ])
      ])
    ]),
    (props.meta != 'taskStages' || __props.hasColor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newColor).value = $event)),
              type: "color",
              required: "",
              class: "w-2/4"
            }, null, 512), [
              [_vModelText, newColor.value]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.hasDesc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newDesc).value = $event)),
              class: "w-full"
            }, null, 512), [
              [_vModelText, newDesc.value]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", { class: "button-row w-full items-center justify-center" }, [
      _createElementVNode("button", {
        type: "button",
        onClick: handleSubmit,
        class: "ac-primary-button text-2xl mt-8"
      }, "Gönder")
    ])
  ], 32))
}
}

})